import { render, staticRenderFns } from "./pop_email.vue?vue&type=template&id=402fd345&scoped=true&"
import script from "./pop_email.vue?vue&type=script&lang=js&"
export * from "./pop_email.vue?vue&type=script&lang=js&"
import style0 from "./pop_email.vue?vue&type=style&index=0&id=402fd345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402fd345",
  null
  
)

export default component.exports